import { isEqual } from "es-toolkit/compat";
import React, { memo } from "react";
import { Skeleton } from "../../../Skeleton";
import type { MoneyCellProps } from "../../types";

// IMPROVE: will use CurrencyDataDisplay component in the future when that's made
const MoneyCell = ({
  value,
  currency = "USD",
  isLoading,
  isBusy,
}: MoneyCellProps) => {
  return (
    <Skeleton
      isLoading={isLoading}
      isBusy={isBusy}
    >
      {value?.toLocaleString("en-US", {
        style: "currency",
        currency,
      }) ?? "-"}
    </Skeleton>
  );
};

export default memo(MoneyCell, isEqual);
